import { isEmpty, isArray, orderBy } from 'lodash';
import React, { useEffect, useState, useCallback } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import update from 'immutability-helper';
import { Container } from 'react-bootstrap';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as action from '../../store/PlanningBottom.action';
import DragList from './DragList';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';

function ChannelList({ setMainState, mainState }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    PlanningBottomReducer,
    Users: { logInRights },
  } = reducer;
  const { ChannelListData } = PlanningBottomReducer;
  const { CheckActionPermission } = useComponent();
  const [channelData, setChannelData] = useState([]);
  const [isDrag, setIsDrag] = useState(false);
  const [state, setState] = useState({
    showConfirmationPopup: false,
    deleteId: null,
    isSelectAll: false,
  });
  const { deleteId, isSelectAll } = state;
  const { selectedIdsArray, showDeleteModal } = mainState;
  const { showConfirmationPopup } = state;
  const [activePopup, setActivePopup] = useState({
    show: false,
    data: {},
    isLoadingConf: false,
  });

  const addEditBottomAccess = CheckActionPermission(logInRights, 'planning', 'bottomUp', 'addEdit');
  const deleteBottomAccess = CheckActionPermission(logInRights, 'planning', 'bottomUp', 'delete');

  useEffect(() => {
    if (!isEmpty(ChannelListData)) {
      const sorted = orderBy(ChannelListData, ['position'], ['asc']);
      setChannelData(sorted);
    } else {
      setChannelData([]);
    }
  }, [ChannelListData]);

  useEffect(() => {
    if (isArray(channelData) && channelData.length > 0) {
      setIsDrag(false);
      const newSequence = [];
      channelData?.forEach((item, index) => {
        newSequence.push({ _id: item?._id, position: index });
      });
      channelData.length > 0 && isDrag && dispatch(action.setChannelSequence(newSequence));
    }
  }, [channelData]);
  const moveTr = useCallback((dragIndex, hoverIndex) => {
    setIsDrag(true);
    setChannelData((prevCards) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      }),
    );
  }, []);
  const openPopupTodelete = (columnId) => {
    setState((state) => ({
      ...state,
      showConfirmationPopup: !state.showConfirmationPopup,
      deleteId: columnId,
    }));
  };
  const handleEditChannelInfo = (obj) => {
    dispatch(action.editChannelInfo(obj));
  };

  const activeInactive = async () => {
    setActivePopup((prev) => ({ ...prev, isLoadingConf: true }));
    const data = activePopup?.data;
    const active = !data.isActive;
    const obj = {
      id: data._id,
      channelName: data.channelName,
      channelType: data.channelType,
      unit: data.unit,
      cost: data.cost,
      isActive: active,
      isDeleted: false,
      position: data.position,
      refKey: data.refKey,
      previousKey: active === false ? data.channelType : false,
    };
    const res = await dispatch(action.editChannel(obj, t));
    if (res) {
      await dispatch(action.getChannelList());
      setActivePopup((prev) => ({
        ...prev,
        show: false,
        data: {},
        isLoadingConf: false,
      }));
    }
  };
  const openActivePopup = (item) => {
    setActivePopup((prev) => ({ ...prev, show: true, data: item }));
  };

  const actionButtons = (item) => {
    return (
      <>
        {addEditBottomAccess && (
          <>
            <button
              type="button"
              className="btn-tbl-action"
              title={t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.EDIT')}
              onClick={() => handleEditChannelInfo(item)}
            >
              <span className="icon-edit" />
            </button>
            <button
              type="button"
              title={t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.ACTIVE_INACTIVE')}
              className="btn-tbl-action"
              onClick={() => openActivePopup(item)}
            >
              {item?.isActive ? <span className="icon-active" /> : <span className="icon-inactive " />}
            </button>

            <button type="button" title={t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.DRAG')} className="btn-tbl-action">
              <span className="icon-expand" />
            </button>
          </>
        )}
        {deleteBottomAccess && (
          <button
            type="button"
            className="btn-tbl-action"
            title={t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.DELETE')}
            onClick={() => openPopupTodelete(item._id)}
          >
            <span className="icon-delete" />
          </button>
        )}
      </>
    );
  };

  const deleteById = async () => {
    const body = {
      channelIds: [deleteId],
    };
    const response = await dispatch(action.deleteChannels(body));
    if (response) {
      await dispatch(action.getChannelList());
      setState((state) => ({
        ...state,
        showConfirmationPopup: false,
        deleteId: null,
      }));
    }
  };

  const renderCard = (item, index) => {
    return (
      <DragList
        item={item}
        index={index}
        actionButtons={actionButtons}
        moveCard={moveTr}
        handleSelection={handleSelection}
        state={mainState}
        deleteBottomAccess={deleteBottomAccess}
        addEditBottomAccess={addEditBottomAccess}
      />
    );
  };

  const handleSelection = (id) => {
    let selectIds = [...selectedIdsArray];
    if (typeof id === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: id,
      }));
      if (!id) selectIds = [];
      else selectIds = channelData.map((ele) => ele._id);
    } else if (id) {
      const itemIndex = selectIds.findIndex((val) => val === id);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(id);
      if (selectIds.length !== channelData.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else if (selectIds.length === channelData.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setMainState((prevState) => ({
      ...prevState,
      selectedIdsArray: selectIds,
    }));
  };

  const multiDelete = async () => {
    const body = {
      channelIds: selectedIdsArray,
    };
    const response = await dispatch(action.deleteChannels(body));
    if (response) {
      await dispatch(action.getChannelList());
      setMainState((prev) => ({
        ...prev,
        showDeleteModal: false,
      }));
    }
  };

  return (
    <Container fluid className="py-3">
      <div className="table-responsive">
        <table className="table font-13 m-0  custom-table layout-fixed font-13 text-center customTable">
          <thead>
            <tr>
              {deleteBottomAccess && (
                <th className="w-50px">
                  <div className="checkbox-label no-label margin-auto">
                    <input
                      type="checkbox"
                      onChange={(e) => handleSelection(e.target.checked)}
                      name="check_all_samples"
                      id="check_all_samples"
                      checked={isSelectAll}
                      disabled={!ChannelListData?.length}
                    />

                    <label htmlFor="check_all_samples" className="chklabel">
                      <span />
                    </label>
                  </div>
                </th>
              )}
              <th className="w-150px">{t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.CHANNEL_NAME')}</th>
              <th>{t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.CHANNEL_TYPE')}</th>
              <th>{t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.UNIT_TYPE')}</th>
              <th>{t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.COST_TYPE')}</th>
              {(addEditBottomAccess || deleteBottomAccess) && <th className="xs-w-110px">{t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.ACTION')}</th>}
            </tr>
          </thead>
          <tbody>
            <DndProvider backend={HTML5Backend}>{!isEmpty(channelData) && channelData?.map((item, index) => renderCard(item, index))}</DndProvider>
          </tbody>
        </table>
        {channelData?.length < 1 && <div className="center-text-table">{t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.NO_RECORD_FOUND')}</div>}

        {showConfirmationPopup && (
          <ConfirmationPopup
            onOpen={showConfirmationPopup}
            onConfirm={deleteById}
            loading={false}
            title={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.TITLE')}
            message={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.DELETE_MESSAGE')}
            toggle={() =>
              setState((state) => ({
                ...state,
                showConfirmationPopup: false,
                deleteId: null,
              }))
            }
          />
        )}

        {showDeleteModal && (
          <ConfirmationPopup
            onOpen={showDeleteModal}
            onConfirm={multiDelete}
            loading={false}
            title={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.TITLE')}
            message={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.DELETE_ALL')}
            toggle={() =>
              setMainState((prestate) => ({
                ...prestate,
                showDeleteModal: false,
              }))
            }
          />
        )}
        {activePopup?.show && (
          <ConfirmationPopup
            onOpen={activePopup?.show}
            onConfirm={activeInactive}
            title={t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.TITLE')}
            message={t('PLANING_BOTTOM_UP.CHANNEL.LIST.CHANNEL_LIST.DELETE_ALL')}
            toggle={() => {
              setActivePopup((prev) => ({ ...prev, show: false }));
            }}
            loading={activePopup?.isLoadingConf}
          />
        )}
      </div>
    </Container>
  );
}

export default ChannelList;
